import { registerGroup, registerImage, registerText } from "@visactor/vrender-kits";

export function loadEmptyTipComponent() {
    registerGroup(), registerText(), registerImage();
}
//# sourceMappingURL=register.js.map